import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, ResetPasswordForm, ChangePasswordForm, CreateAccountForm } from './components';
import GlobalParams from './helpers/GlobalParams';
import { useEffect, useState } from 'react';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import NewQuotation from './pages/NewQuotation/NewQuotation';
import env from "react-dotenv";

export default function UnauthenticatedContent() {
  console.log("BASE URL IS: "+ process.env.baseURL);
  const [loading, setLoading] = useState(false);
  const [tokenReceived, setTokenReceived] = useState(false);
  
  useEffect(() => {
    const api_authentication = async () => {
      GlobalParams.bearerToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5OWIxYmVhZi0xZmI4LTQwNzctYjUzMy0wNjk5MjQ3Mjg1MmIiLCJqdGkiOiJiOTM1YjI5YzAxYjkwN2RjOTg4MTNmMTBhYTk3MjIwNGEyZjExN2ExMjQ3M2E2ZWI4ZWZhOGUwNWU0NTBiMDFiYzJiZGI2OGE4YzZhMGJiNiIsImlhdCI6MTc2MzQ1ODM0NC4zNzQzMjYsIm5iZiI6MTc2MzQ1ODM0NC4zNzQzMjksImV4cCI6MTc5NDk5NDM0NC4zMDA2MzYsInN1YiI6IiIsInNjb3BlcyI6W119.Y8xZuzYZV1vRPY7Av4rpKI-6_JguFzEeQz2G_yikblI2SWvJLkdHb03lcX2LV-iJAFKM__aP83_1u_UmHiG8V3ui5UHrFQAf7tvDTLYYQ-IKiPCi1NZT1E46W-P7rhGorvAQORcRR0MF8LvTmMZpnz6cMHXv6j1WyABuvzha3UtBwnQxecSKN1olAvY3afYQe4vNZyMy98bB2K4U-Cnj218R87NsR-cRjEkZJnHWXjugdo-C2-1rPnQAQcnS3E33y9z2iwD0cyd7UGQe5YUZ-Pub0pvo75YovG7Ko1xHssJwnKGb4jVipeKlcwhM5wRT-kKcvks1c3GDOHa33NNHOziC0SlBFT0DS6IbFGZ-0vkWa7Sn88qsfWNlVnpy0abFGZIGFc6dRT-Dj_tJ_NiCgEekYG6cn1NfZMcEmTLpy5k4xHK4LGj-WF5UHKE0y6IF5VdO19BRihxH4z3-RhOMdYvAvav-wApj_zA6KWzu2OKgczS8soxVfk3XP1a7Wd8Xv4fQZ28Q2CyOPfGsuKJ636Txi3av7PYfpzejkTgqbB1odUmey09ttzkxVn3mkchUJR-B_pj4tvfx-C7A8p7mLhXNYNwrGj4M_VRxnDVTJTh4ItoeaPOwKYBPRE5zQGo4-2EENh_3lIzdYaB_l3Pu1f0u4_4ouLYgGF0AUKPDKV8";
      setTokenReceived(true);
      setLoading(false);
      // try {
      //   const response = await axios.post(
      //     '/GLICO_GL_API/generate-token',
      //     {},
      //     {
      //       headers: {
      //         'Content-Type': 'text/html; charset=UTF-8',
      //         //'Cache-Control':  'no-cache'
      //       }
      //     }
      //   );
      //   GlobalParams.bearerToken = response.data.data.access_token;
      //   setTokenReceived(true);
      //   setLoading(false);
      // } catch (error) {
      //   setLoading(false);
      //   console.log(error);
      //   notify("Access Denied", 'error', 5000);
      // }
    };

    api_authentication();
  }, []);

  return (
    <Routes>
      <Route
        path='/login' 
        element={
          <SingleCard title="">
            <LoginForm />
          </SingleCard>
        }
      />
      <Route
        path='/create-account'
        element={
          <SingleCard title="Sign Up">
            <CreateAccountForm />
          </SingleCard>
        }
      />
      <Route 
        path='/reset-password'
        element={
          <SingleCard
            title="Reset Password"
            description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
          >
            <ResetPasswordForm />
          </SingleCard>
        }
      />
      <Route
        path='/change-password/:recoveryCode'
        element={
          <SingleCard title="Change Password">
            <ChangePasswordForm />
          </SingleCard>
        }
      />
      <Route 
        path='/new-quotation'
        element={
          <SingleCard
            title="Quotation"
            description="Please fill the quotation form after which BRITAM will get back to you."
          >
            <NewQuotation />
          </SingleCard>
        }
      />
      {/* Only navigate to login if tokenReceived == true */}
      {tokenReceived && <Route path='*' element={<Navigate to={'/login'} />} />}
    </Routes>
  );
}
